import { languageConfig } from "i18n/language-config";
import { NextPage } from "next";
import { INextPageProps } from "../../app";
import Seo from "domain/SeoAndAnalytics/Seo";
import { frontendUrlBuilder } from "../../utils/routing/frontend-url-builder";
import { useRouter } from "next/router";
import { PrivacyHubContent } from "domain/Privacy/PrivacyHubContent";
import { useTranslations } from "next-intl";
import { AbstractIntlMessages } from "next-intl";
import { loadServerTranslations } from "../../i18n/messages";

interface Props extends INextPageProps {
  locale: string;
  messages: AbstractIntlMessages;
}

const PrivacyHub: NextPage<Props> = () => {
  const t = useTranslations("page-privacy-hub");
  const router = useRouter();

  return (
    <>
      <Seo
        title={t("seo.metaTitle")}
        description={t("seo.metaDescription")}
        canonical={frontendUrlBuilder.buildCanonicalUrl(router.asPath)}
      />
      <PrivacyHubContent />
    </>
  );
};

export const getStaticProps = async ({ params: { lang = null } = {} }) => {
  if (!languageConfig.isLanguageAllowedInPath(lang)) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }

  const locale = languageConfig.mapLanguageToLocale(lang);
  const messages = await loadServerTranslations(locale, ["common", "page-privacy-hub"]);

  return {
    props: {
      locale,
      messages,
    },
    revalidate: 60,
  };
};

export async function getStaticPaths() {
  const langs = languageConfig.getLanguages();
  const paths = langs
    .filter((lang) => lang != "en")
    .map((lang) => ({
      params: { lang },
    }));

  return {
    paths,
    fallback: true,
  };
}

export default PrivacyHub;
